import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import toast from 'react-hot-toast';
import { requestLocationPermission } from './geolocation';
import { hideNativeSplashWhenReady } from './nativeSplash';
import { hapticWarning } from './haptics';
import { ensureNativeGoogleInitialized, getGoogleWebClientId } from '../services/auth/nativeGoogleSignIn';
const EXIT_BACK_MS = 2000;
let lastBackPressAt = 0;

/**
 * 初始化 Capacitor 移动端功能
 */
export const initCapacitor = async () => {
  if (!Capacitor.isNativePlatform()) {
    console.log('🌐 Running on web platform');
    return;
  }

  document.documentElement.classList.add('native-app');

  console.log('📱 Running on native platform:', Capacitor.getPlatform());

  try {
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#1d3557' });

    // Splash 由 AuthBootstrapGate 隱藏；此處僅作安全超時（避免卡死）
    window.setTimeout(() => {
      void hideNativeSplashWhenReady();
    }, 10000);

    Keyboard.setAccessoryBarVisible({ isVisible: true });
    Keyboard.setScroll({ isDisabled: false });

    requestLocationPermission().catch((err) => {
      console.warn('[Capacitor] Location permission prompt skipped:', err);
    });

    App.addListener('appStateChange', ({ isActive }) => {
      console.log('App state changed. Is active?', isActive);
    });

    if (getGoogleWebClientId()) {
      ensureNativeGoogleInitialized().catch((err) => {
        console.warn('[Capacitor] Native Google init skipped:', err);
      });
    }

    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
        return;
      }

      const now = Date.now();
      if (now - lastBackPressAt < EXIT_BACK_MS) {
        App.exitApp();
        return;
      }

      lastBackPressAt = now;
      void hapticWarning();
      toast('再按一次離開應用程式', { duration: EXIT_BACK_MS, id: 'exit-app-hint' });
    });

    console.log('✅ Capacitor initialized successfully');
  } catch (error) {
    console.error('❌ Error initializing Capacitor:', error);
  }
};

export const isMobile = (): boolean => {
  return (
    Capacitor.isNativePlatform() ||
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
};

export const getPlatform = (): string => {
  return Capacitor.getPlatform();
};

export const isIOS = (): boolean => {
  return Capacitor.getPlatform() === 'ios';
};

export const isAndroid = (): boolean => {
  return Capacitor.getPlatform() === 'android';
};
